// NotificationPermission.js
import { useEffect } from "react";

function useNotificationPermission() {
  useEffect(() => {
    if ("Notification" in window) {
      if (Notification.permission === "default") {
        Notification.requestPermission();
      }
    }
  }, []);
}

export default useNotificationPermission;
